<template>
    <div class="header">
        <div class="nav">
            <div class="links">
                <router-link to="/" tag="img" class="logo" draggable="false" src="logo.svg"/>
                <router-link tag="div" class="btn-nav" to='/'>Overview</router-link>
                <router-link tag="div" class="btn-nav" to='/customers'>Customers</router-link>
                <router-link tag="div" class="btn-nav" to='/products'>Products</router-link>
                <router-link tag="div" class="btn-nav" to='/invoices'>Invoices</router-link>
                <router-link tag="div" class="btn-nav" to='/cases'>Cases</router-link>
                <router-link tag="div" class="btn-nav" to='/apps'>Apps</router-link>
            </div>
            <div class="profile">
                <v-gravatar draggable="false" tabindex="-1" :email="$store.state.account.email"/>
                <div class="profile-menu">
                    <div>{{$store.state.account.name}}</div>
                    <a target="_blank" href="https://drive.google.com/drive/u/2/folders/0AGprT9n74PcCUk9PVA" class="btn-nav">Assets</a>
                    <a target="_blank" href="https://auth.infrequent.net/account" class="btn-nav">Account</a>
                    <div class="btn-nav" v-on:click="logout()">Sign out</div>
                </div>
            </div>
        </div>
        <div class="flex-side-by-side">
            <div class="details">
                <h1>Customer Connect</h1>
                <p>Manage all your clients</p>
            </div>
            <div v-if="supporters.length > 1" class="online-supporters">
                <h4>Supporters online with you</h4>
                <div class="supporters">
                    <v-gravatar v-for="(email, index) in supporters.filter((v,i) => supporters.indexOf(v) === i)" :key="index" :class="{'me' : email == $store.state.account.email}" draggable="false" :email="email"/>
                </div>
            </div>
            <div v-else class="online-supporters">
                <h4>No supporters online with you</h4>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Header',
    data() {
        return {
            supporters: [],
        }
    },
    sockets: {
        onlineSocket(data){
            this.supporters = data;
        },
    },
    methods: {
        logout(){
            this.$store.state.account = null;
            delete localStorage.token
            this.$router.go('/');
        },
    },
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/global.scss';

div.header{
    user-select: none;
    min-height: 250px;
    height: max-content;
    background-color: #f8951f;
    background-image: linear-gradient(45deg, #00796b, #263238);
    color: white;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    display: flex;
    padding: 0 0 2.5rem 0;
    flex-direction: column;
    justify-content: space-between;
    z-index: 100;
    position: relative;
    &>*{
        margin: 0 auto;
        width: 80%;
        max-width: 2000px;
        @media(max-width: 800px){
            margin-left: 2rem;
            margin-right: 2rem;
            width: calc(100% - 4rem);
        }
        @media(max-width: 500px) {
            margin-left: 1rem;
            margin-right: 1rem;
            width: calc(100% - 2rem);
        }
    }
    div.nav{
        font-size: 0.9rem;
        padding: 1rem 0;
        height: calc(40px + 2rem);
        display: flex;
        justify-content: space-between;
        &>div{
            display: flex;
            &.links{
                padding: 1rem 0;
                margin: -1rem 0;
                overflow-x: auto;
                &::-webkit-scrollbar {
                    display: none;
                }
            }
            .logo{
                opacity: 0.8;
                width: 40px;
                margin-right: 1rem;
                cursor: pointer;
                transition: opacity 300ms ease;
                &:hover{
                    opacity: 1;
                }
                @media(max-width: 800px){
                    margin-right: 5px;
                } 
            }
            &>div.btn-nav{
                background-color: transparent;
                margin: 3px 0;
                box-shadow: none;
                &:not(:last-child){
                    margin-right: 5px;
                }
                flex-grow: 0;
                flex-shrink: 0;
                border-radius: 5px;
                padding: 8px 15px;
                @media(max-width: 800px){
                    font-size: 14px;
                    padding: 3px 5px;
                    margin: 8px 0;
                    &:not(:last-child){
                        margin-right: 0;
                    }
                }            
                transition: background-color 300ms ease,
                box-shadow 300ms ease;
                user-select: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                text-align: center;
                height: max-content;
                width: max-content;
                &.router-link-exact-active{
                    pointer-events: none;
                    cursor: default;
                    background-color: rgba(white,0.1);
                    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
                }
                &:hover:not(.router-link-exact-active){
                    background-color: rgba(white,0.19);
                    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
                }
            }
            &.profile{
                height: 100%;
                position: relative;
                flex-shrink: 0;
                margin-left: 5px;
                img{
                    height: 40px;
                    width: 40px;
                    border-radius: 50%;
                    object-fit: cover;
                    cursor: pointer;
                    background-color: rgba(white, 0.1);
                    transition: background-color 300ms ease, box-shadow 300ms ease;
                    &:hover, &:focus{
                        background-color: rgba(white,0.19);
                        box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
                    }
                }
                img:focus ~ .profile-menu, .profile-menu:focus, &:focus-within .profile-menu, &:focus .profile-menu{
                    opacity: 1;
                    pointer-events: all;
                }
                .profile-menu{
                    opacity: 0;
                    pointer-events: none;
                    transition: opacity 300ms ease;
                    position: absolute;
                    top: calc(0.5rem + 100%);
                    right: 0;
                    min-width: 180px;
                    border-radius: 5px;
                    background-color: rgba(black, 0.6);
                    backdrop-filter: blur(10px);
                    color: rgba(white, 0.8);
                    min-height: 100px;
                    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
                    z-index: 100;
                    div, a{
                        padding: 15px 15px;
                        min-width: max-content;
                        width: 100%;
                        &:not(:last-child){
                            border-bottom: 1px solid rgba(white, 0.15);
                        }
                        &.btn-nav{
                            padding: 10px 15px;
                            font-size: 0.8rem;
                            cursor: pointer;
                            transition: background-color 300ms ease;
                            &:hover{
                                background-color: rgba(white, 0.05);
                            }
                        }
                    }
                }
            }
        }
        a{
            color: inherit;
            text-decoration: none;
            display: block;
        }
    }
    .details{
        padding: 0 1.5rem;
        h1{
            margin: 0;
        }
        p{
            margin: 0.6rem 0 0.6rem 0;
            font-size: 1.2rem;
        }
    }
    .flex-side-by-side{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex-wrap: wrap;
    }
    .online-supporters{
        margin-left: auto;
        h4{
            margin-bottom: 10px;
            &:last-child{
                margin-bottom: 0;
            }
        }
        .supporters{
            display: flex;
            flex-direction: row-reverse;
            justify-content: flex-start;
            margin-right: 5px;
            &>*{
                &.me{
                    display: none;
                }
                margin-right: -5px;
                height: 40px;
                width: 40px;
                border-radius: 50%;
                object-fit: cover;
                cursor: default;
                background-color: rgba(white, 0.1);
                transition: background-color 300ms ease, box-shadow 300ms ease;
                &:hover{
                    background-color: rgba(white,0.19);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
                }
                animation: entrence 800ms forwards;
                @keyframes entrence {
                    0%{
                        transform: scale(0);
                    }
                    60%{
                        transform: scale(1.2);
                    }
                    100%{
                        transform: scale(1);
                    }
                }
            }
        }
    }
}
</style>
